import { useQueryClient } from '@tanstack/react-query'
import { useRealtime } from '@/lib/ws/useRealtime'
import { adminKeys } from './api'

export function AdminRealtime() {
  const qc = useQueryClient()
  useRealtime(
    (event) => event === 'infra.renewal.due' || event === 'renewal.due',
    () => {
      void qc.invalidateQueries({ queryKey: adminKeys.all })
    },
  )
  return null
}
